import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { format, subDays } from "date-fns";
import { Grid } from "@mui/material";
import MetricValue from "../../metrics/metric-value";
import MetricTrend from "../../metrics/metric-trend";
import { getTrendLabels, getLabels } from "../../../../helpers/metrics";
import { useApiTenant } from "../../../../api/api-tenant";
import useOnScreen from "../../../../helpers/on-screen";
export default function TicketsMetricsSummary({ type, group_id, contact_id, user_id, campaign, globalRange, setGlobalRange, globalStartDate, globalStartTime, globalEndDate, globalEndTime, setIsLoading, isChosenGlobalCustomRange, }) {
    const { t } = useTranslation();
    const api = useApiTenant();
    const ref = useRef(null);
    const onScreen = useOnScreen(ref, "-100px");
    const [wasOnScreen, setWasOnScreen] = useState(false);
    const [ticketsValue, setTicketsValue] = useState(0);
    const [ticketsValueCachedAt, setTicketsValueCachedAt] = useState("");
    const [ticketsValueError, setTicketsValueError] = useState(false);
    const [ticketsValueRange, setTicketsValuesRange] = useState("total");
    const [ticketsValueLoading, setTicketsValueLoading] = useState(true);
    const [ticketsValueStartDate, setTicketsValueStartDate] = useState("");
    const [ticketsValueEndDate, setTicketsValueEndDate] = useState("");
    const [ticketsValueStartTime, setTicketsValueStartTime] = useState("");
    const [ticketsValueEndTime, setTicketsValueEndTime] = useState("");
    const [isChosenValueCustomRange, setIsChosenValueCustomRange] = useState(false);
    const [ticketsValueChosenStatuses, setTicketsValueChosenStatuses] = useState([]);
    const [ticketsValueChosenPriorities, setTicketsValueChosenPriorities] = useState([]);
    const [ticketsTrendLabels, setTicketsTrendLabels] = useState([]);
    const [ticketsTrendError, setTicketsTrendError] = useState(false);
    const [ticketsTrendValues, setTicketsTrendValues] = useState([]);
    const [ticketsTrendCachedAt, setTicketsTrendCachedAt] = useState("");
    const [ticketsTrendRange, setTicketsTrendRange] = useState("last_30_days");
    const [ticketsTrendLoading, setTicketsTrendLoading] = useState(true);
    const [ticketsTrendChosenStatuses, setTicketsTrendChosenStatuses] = useState([]);
    const [ticketsTrendChosenPriorities, setTicketsTrendChosenPriorities] = useState([]);
    const [ticketsValueMetricsRefresh, setTicketsValueMetricsRefresh] = useState(false);
    const [ticketsTrendMetricsRefresh, setTicketsTrendMetricsRefresh] = useState(false);
    const getTicketsValue = invalidateCache => {
        setTicketsValueLoading(true);
        if (ticketsValueError)
            setTicketsValueError(false);
        let startTime;
        let endTime;
        if (ticketsValueRange === "custom" &&
            ticketsValueStartDate !== "" &&
            ticketsValueEndDate !== "") {
            if (ticketsValueStartTime !== "") {
                startTime =
                    format(new Date(ticketsValueStartDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(ticketsValueStartTime), "HH:mm:ss");
            }
            else {
                startTime = format(new Date(ticketsValueStartDate), "yyyy-MM-dd") + " 00:00:00";
            }
            if (ticketsValueEndTime !== "") {
                endTime =
                    format(new Date(ticketsValueEndDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(ticketsValueEndTime), "HH:mm") +
                        ":59";
            }
            else {
                endTime = format(new Date(ticketsValueEndDate), "yyyy-MM-dd") + " 23:59:59";
            }
        }
        api.GET_metrics("count", "tickets", ticketsValueRange, type === "contact" ? "contact_id" : type === "campaign" ? "campaign_id" : undefined, type === "contact" ? contact_id : type === "campaign" ? campaign.id : undefined, type === "group"
            ? "groups,is_draft"
            : type === "user"
                ? "created_by,is_draft"
                : type === "campaign_group"
                    ? "campaign_id,is_draft,groups"
                    : "is_draft", type === "group"
            ? group_id + ",0"
            : type === "user"
                ? user_id + ",0"
                : type === "campaign_group"
                    ? campaign.id + ",0," + group_id
                    : "0", type === "campaign_group" || type === "group" ? 1 : undefined, invalidateCache ? 1 : undefined, ticketsValueRange === "custom" ? startTime : undefined, ticketsValueRange === "custom" ? endTime : undefined, undefined, undefined, campaign && ticketsValueChosenStatuses.length > 0
            ? ticketsValueChosenStatuses.map(i => i.id)
            : undefined, campaign && ticketsValueChosenPriorities.length > 0
            ? ticketsValueChosenPriorities.map(i => i.id)
            : undefined)
            .then(response => {
            setTicketsValue(response.data.count);
            setTicketsValueCachedAt(response.data.cached_at);
            setTicketsValueLoading(false);
        })
            .catch(error => {
            setTicketsValueError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setTicketsValueLoading(false);
            }
        });
        return () => api.cancel();
    };
    const getTicketsTrendValues = invalidateCache => {
        setTicketsTrendLoading(true);
        if (ticketsTrendError)
            setTicketsTrendError(false);
        let trendsLabels = getTrendLabels(ticketsTrendRange);
        let labels = getLabels(trendsLabels, ticketsTrendRange);
        setTicketsTrendLabels(labels);
        let interval = ticketsTrendRange;
        let startDate;
        let endDate;
        if (ticketsTrendRange === "last_7_days") {
            interval = "custom";
            startDate = format(subDays(new Date(), 6), "yyyy-MM-dd") + " 00:00:00";
            endDate = format(new Date(), "yyyy-MM-dd") + " 23:59:59";
        }
        else if (ticketsTrendRange === "last_30_days") {
            interval = "custom";
            startDate = format(subDays(new Date(), 29), "yyyy-MM-dd") + " 00:00:00";
            endDate = format(new Date(), "yyyy-MM-dd") + " 23:59:59";
        }
        api.GET_metrics("trend", "tickets", interval, undefined, undefined, type === "group"
            ? "groups,is_draft"
            : type === "user"
                ? "created_by,is_draft"
                : type === "campaign"
                    ? "campaign_id,is_draft"
                    : type === "campaign_group"
                        ? "campaign_id,is_draft,groups"
                        : type === "contact"
                            ? "contact_id,is_draft"
                            : "is_draft", type === "group"
            ? group_id + ",0"
            : type === "user"
                ? user_id + ",0"
                : type === "campaign"
                    ? campaign.id + ",0"
                    : type === "campaign_group"
                        ? campaign.id + ",0," + group_id
                        : type === "contact"
                            ? contact_id + ",0"
                            : "0", type === "group" || type === "campaign_group" ? 1 : undefined, invalidateCache ? 1 : undefined, startDate, endDate, undefined, undefined, campaign && ticketsTrendChosenStatuses.length > 0
            ? ticketsTrendChosenStatuses.map(i => i.id)
            : undefined, campaign && ticketsTrendChosenPriorities.length > 0
            ? ticketsTrendChosenPriorities.map(i => i.id)
            : undefined)
            .then(response => {
            let values = [];
            trendsLabels.map(label => {
                if (response.data.data.find(a => a.date === label)) {
                    values.push(response.data.data.find(a => a.date === label).count);
                }
                else {
                    values.push(0);
                }
            });
            setTicketsTrendCachedAt(response.data.cached_at);
            setTicketsTrendValues(values);
            setTicketsTrendLoading(false);
        })
            .catch(error => {
            setTicketsTrendError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setTicketsTrendLoading(false);
            }
        });
        return () => api.cancel();
    };
    useEffect(() => {
        if (onScreen && !wasOnScreen)
            setWasOnScreen(true);
    }, [onScreen]);
    useEffect(() => {
        if (wasOnScreen)
            setWasOnScreen(false);
        if (isChosenGlobalCustomRange &&
            globalRange === "custom" &&
            globalStartDate &&
            globalStartDate !== "" &&
            globalEndDate &&
            globalEndDate !== "") {
            setIsLoading(true);
            setTicketsValueStartDate(globalStartDate);
            setTicketsValueEndDate(globalEndDate);
            if (globalStartTime) {
                setTicketsValueStartTime(globalStartTime);
            }
            else {
                setTicketsValueStartTime("");
            }
            if (globalEndTime) {
                setTicketsValueEndTime(globalEndTime);
            }
            else {
                setTicketsValueEndTime("");
            }
            setTicketsValuesRange(globalRange);
            setIsChosenValueCustomRange(true);
        }
    }, [isChosenGlobalCustomRange]);
    useEffect(() => {
        if (wasOnScreen && ticketsValueRange !== "custom") {
            setTicketsValueStartDate("");
            setTicketsValueEndDate("");
            setTicketsValueStartTime("");
            setTicketsValueEndTime("");
            getTicketsValue(undefined);
        }
    }, [ticketsValueRange, wasOnScreen]);
    useEffect(() => {
        if (setGlobalRange &&
            globalRange !== "none" &&
            (ticketsValueRange !== globalRange ||
                (ticketsValueRange === globalRange &&
                    (globalStartDate !== ticketsValueStartDate ||
                        globalStartTime !== ticketsValueStartTime ||
                        globalEndDate !== ticketsValueEndDate ||
                        globalEndTime !== ticketsValueEndTime)))) {
            setGlobalRange("none");
        }
        if (isChosenValueCustomRange &&
            ticketsValueStartDate !== "" &&
            ticketsValueEndDate !== "") {
            getTicketsValue(undefined);
        }
    }, [isChosenValueCustomRange]);
    useEffect(() => {
        if (ticketsValueMetricsRefresh) {
            getTicketsValue(true);
            setTicketsValueMetricsRefresh(false);
        }
        if (ticketsTrendMetricsRefresh) {
            getTicketsTrendValues(true);
            setTicketsTrendMetricsRefresh(false);
        }
    }, [ticketsValueMetricsRefresh, ticketsTrendMetricsRefresh]);
    useEffect(() => {
        if (ticketsValueChosenPriorities.length !== 0 || ticketsValueChosenStatuses.length !== 0) {
            getTicketsValue(false);
        }
    }, [ticketsValueChosenPriorities.length, ticketsValueChosenStatuses.length]);
    useEffect(() => {
        if (wasOnScreen) {
            getTicketsTrendValues(undefined);
        }
    }, [ticketsTrendRange, wasOnScreen]);
    useEffect(() => {
        if (ticketsTrendChosenPriorities.length !== 0 || ticketsTrendChosenStatuses.length !== 0)
            getTicketsTrendValues(false);
    }, [ticketsTrendChosenPriorities.length, ticketsTrendChosenStatuses.length]);
    return (_jsxs(Grid, Object.assign({ ref: ref, container: true, spacing: 4, width: "100%", marginLeft: "0px", paddingTop: "32px" }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12, md: 5, xl: 4 }, { children: _jsx(MetricValue, { title: t("tickets.tickets"), value: ticketsValue, range: ticketsValueRange, setRange: setTicketsValuesRange, isLoading: ticketsValueLoading, setIsLoading: setTicketsValueLoading, cachedAt: ticketsValueCachedAt, refresh: ticketsValueMetricsRefresh, setRefresh: setTicketsValueMetricsRefresh, startDate: ticketsValueStartDate, setStartDate: setTicketsValueStartDate, endDate: ticketsValueEndDate, setEndDate: setTicketsValueEndDate, startTime: ticketsValueStartTime, setStartTime: setTicketsValueStartTime, endTime: ticketsValueEndTime, setEndTime: setTicketsValueEndTime, globalRange: globalRange, setGlobalRange: setGlobalRange, setIsChosenCustomRange: setIsChosenValueCustomRange, isError: ticketsValueError, statuses: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_statuses : undefined, priorities: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_priorities : undefined, chosenStatuses: campaign ? ticketsValueChosenStatuses : undefined, setChosenStatuses: campaign ? setTicketsValueChosenStatuses : undefined, chosenPriorities: campaign ? ticketsValueChosenPriorities : undefined, setChosenPriorities: campaign ? setTicketsValueChosenPriorities : undefined }) })), _jsx(Grid, Object.assign({ item: true, xs: 12, md: 7, xl: 8 }, { children: _jsx(MetricTrend, { title: t("tickets.metrics.tickets-trend"), label: t("tickets.tickets"), labels: ticketsTrendLabels, values: ticketsTrendValues, range: ticketsTrendRange, setRange: setTicketsTrendRange, isLoading: ticketsTrendLoading, setIsLoading: setTicketsTrendLoading, cachedAt: ticketsTrendCachedAt, refresh: ticketsTrendMetricsRefresh, setRefresh: setTicketsTrendMetricsRefresh, isError: ticketsTrendError, statuses: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_statuses : undefined, priorities: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_priorities : undefined, chosenStatuses: campaign ? ticketsTrendChosenStatuses : undefined, setChosenStatuses: campaign ? setTicketsTrendChosenStatuses : undefined, chosenPriorities: campaign ? ticketsTrendChosenPriorities : undefined, setChosenPriorities: campaign ? setTicketsTrendChosenPriorities : undefined }) }))] })));
}
